// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JS_Lp","col":"styles_col__3Eylk","actions":"styles_actions__1pUsJ","conflict":"styles_conflict__3wYvf"};